module.exports = __webpack_public_path__ + "static/media/invoice-icon.22c670fd.svg";